import React from "react";
import PropTypes from "prop-types";
import { Select } from "formik-antd";

import { Typography, Space } from "antd";

const { Text, Link } = Typography;

const renderItem = (props) => {
    if (props.description) {
        return (
            <Select.Option key={props.value} value={props.value} label={props.label} style={{ width: "100%" }}>
                <Space direction="vertical" style={{ width: "100%" }} size="small">
                    <Text>{props.label}</Text>
                    <Typography.Paragraph type="secondary" style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                        ↳ {props.description}
                    </Typography.Paragraph>
                </Space>
            </Select.Option>
        );
    }

    return (
        <Select.Option key={props.value} value={props.value} label={props.label}>
            {props.label}
        </Select.Option>
    );
};

const SelectWithDescription = ({ options, ...props }) => {
    const renderItems = (list) => (list || []).map((item) => renderItem(item));

    return (
        <Select {...props} optionLabelProp="label">
            {(options || []).map((item) => {
                if (item.options) {
                    return <Select.OptGroup label={item.label}>{renderItems(item.options)}</Select.OptGroup>;
                }

                return renderItem(item);
            })}
        </Select>
    );
};

export default SelectWithDescription;
